import { useApi } from './useApi';
import { apiService } from '../services/api';

interface BehandelingenIntroData {
  id: number;
  documentId: string;
  title?: string;
  text: string;
  backgroundColor?: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useBehandelingenIntro() {
  return useApi<BehandelingenIntroData>(apiService.getBehandelingenIntro);
}